export function bodyOverflow(overflow = false) {
    if (overflow){
        const scrollBarWidth = window.innerWidth - document.body.offsetWidth;
t
        document.body.style.marginRight = `${scrollBarWidth}px`;
        document.body.classList.add('body-overflow');
    } else{
        document.body.classList.remove('body-overflow');
        document.body.style.marginRight = `0`;
    }
}

export const is_iOS = () => (/iPad|iPhone|iPod/.test(navigator.userAgent) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) || (navigator.platform.toUpperCase().indexOf('MAC') >= 0) &&
    !window.MSStream
